
document.addEventListener('DOMContentLoaded', () => {
  // Topic chip select (Contact page)
  const chips = document.querySelectorAll('.topic-chip');
  if (chips.length > 0) {
    chips.forEach(c => {
      c.addEventListener('click', () => {
        chips.forEach(x => x.classList.remove('active'));
        c.classList.add('active');
      });
    });
  }

  // Design Handoff Navigation & Viewport controls (Index page wrapper)
  const nav = document.getElementById('nav');
  if (nav) {
    const frame = document.getElementById('frame');
    const welcome = document.getElementById('welcome');
    const crumb = document.getElementById('crumb-page');
    const openNew = document.getElementById('openNew');
    const frameInner = document.getElementById('frameInner');
    const viewport = document.getElementById('viewport');
    
    function showPage(page, label) {
      document.querySelectorAll('#nav a').forEach(a => a.classList.toggle('active', a.dataset.page === page));
      if (!page) {
        if (frame) frame.style.display = 'none';
        if (welcome) welcome.style.display = 'block';
        if (crumb) crumb.textContent = 'Overview';
        if (openNew) openNew.style.display = 'none';
        return;
      }
      if (welcome) welcome.style.display = 'none';
      if (frame) {
        frame.style.display = 'block';
        frame.src = encodeURI(page);
      }
      if (crumb) crumb.textContent = label || page.replace('.html','');
      if (openNew) {
        openNew.href = encodeURI(page);
        openNew.style.display = 'inline-flex';
      }
    }
    
    nav.addEventListener('click', e => {
      const a = e.target.closest('a[data-page]');
      if (!a) return;
      e.preventDefault();
      showPage(a.dataset.page, a.textContent.trim().replace('START',''));
    });
    
    document.querySelectorAll('.page-card').forEach(c => {
      c.addEventListener('click', e => {
        e.preventDefault();
        const page = c.dataset.page;
        const label = c.querySelector('strong').textContent;
        showPage(page, label);
      });
    });
    
    if (viewport) {
      viewport.addEventListener('click', e => {
        const b = e.target.closest('button[data-vp]');
        if (!b) return;
        viewport.querySelectorAll('button').forEach(x => x.classList.remove('active'));
        b.classList.add('active');
        if (frameInner) {
          frameInner.classList.remove('mobile','tablet');
          if (b.dataset.vp === 'mobile') frameInner.classList.add('mobile');
          if (b.dataset.vp === 'tablet') frameInner.classList.add('tablet');
        }
      });
    }
  }
});
